document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.menu-button');
  const nav = document.querySelector('.nav-bar');
  if (menu && nav) {
    menu.setAttribute('role', 'button');
    menu.setAttribute('aria-label', 'Toggle menu');
    menu.setAttribute('aria-expanded', 'false');
    menu.addEventListener('click', event => {
      event.preventDefault();
      const open = nav.classList.toggle('bythlon-menu-open');
      menu.setAttribute('aria-expanded', String(open));
    });
  }
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const mainImage = gallery.querySelector('[data-gallery-image]');
    const dialog = gallery.querySelector('dialog');
    const enlargedImage = gallery.querySelector('[data-gallery-enlarged]');
    const openButton = gallery.querySelector('[data-gallery-open]');
    const status = gallery.querySelector('[data-gallery-status]');
    const caption = gallery.querySelector('[data-gallery-caption]');
    const videoPanel = gallery.querySelector('[data-gallery-video]');
    const replay = videoPanel?.querySelector('video');
    const enlargedVideo = gallery.querySelector('[data-gallery-enlarged-video]');
    let index = 0;
    const showImage = nextIndex => {
      index = (nextIndex + thumbnails.length) % thumbnails.length;
      const selected = thumbnails[index];
      const isVideo = selected.dataset.video === 'true';
      if (videoPanel) videoPanel.hidden = !isVideo;
      openButton.hidden = isVideo;
      if (!isVideo) {
        replay?.pause();
        mainImage.srcset = selected.dataset.srcset;
        mainImage.src = selected.dataset.src;
        mainImage.alt = selected.dataset.alt;
      }
      enlargedVideo?.pause();
      thumbnails.forEach((thumbnail, position) => thumbnail.setAttribute('aria-pressed', String(position === index)));
      status.textContent = `${index + 1} / ${thumbnails.length}`;
      if (dialog.open) {
        enlargedImage.hidden = isVideo;
        if (enlargedVideo) enlargedVideo.hidden = !isVideo;
        if (!isVideo) {
          enlargedImage.src = selected.dataset.full;
          enlargedImage.alt = selected.dataset.alt;
        }
        caption.textContent = `${index + 1} / ${thumbnails.length} — ${selected.dataset.caption}`;
      }
    };
    thumbnails.forEach((thumbnail, position) => thumbnail.addEventListener('click', () => showImage(position)));
    gallery.querySelectorAll('[data-gallery-prev]').forEach(button => button.addEventListener('click', () => showImage(index - 1)));
    gallery.querySelectorAll('[data-gallery-next]').forEach(button => button.addEventListener('click', () => showImage(index + 1)));
    openButton.addEventListener('click', () => {
      replay?.pause();
      dialog.showModal();
      document.documentElement.classList.add('bythlon-gallery-open');
      showImage(index);
    });
    gallery.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('bythlon-gallery-open');
      enlargedVideo?.pause();
      (openButton.hidden ? thumbnails[index] : openButton).focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const buttons = [...dialog.querySelectorAll('button')];
      const first = buttons[0];
      const last = buttons[buttons.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    gallery.addEventListener('keydown', event => {
      if (event.target.closest('video')) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      event.stopPropagation();
      const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
      showImage(nextIndex);
      if (event.target.matches('[data-gallery-thumbnail]')) thumbnails[index].focus();
    });
  });
  if (window.Swiper) {
    const initSliders = () => document.querySelectorAll('.testimonial-slider_component').forEach(component => {
      const slider = component.querySelector('.swiper');
      if (!slider || !slider.offsetWidth || slider.swiper) return;
      new window.Swiper(slider, {
        slidesPerView: 'auto',
        followFinger: true,
        freeMode: false,
        slideToClickedSlide: false,
        centeredSlides: false,
        autoHeight: false,
        speed: 300,
        slideActiveClass: 'is-active',
        slideDuplicateActiveClass: 'is-active',
        mousewheel: { forceToAxis: true },
        keyboard: { enabled: true, onlyInViewport: true },
        navigation: {
          nextEl: component.querySelector('.testimonial-slider_btn_element.is-next'),
          prevEl: component.querySelector('.testimonial-slider_btn_element.is-prev'),
        },
        pagination: {
          el: component.querySelector('.testimonial-slider_bullet_wrap'),
          bulletActiveClass: 'is-active',
          bulletClass: 'testimonial-slider_bullet_item',
          bulletElement: 'button',
          clickable: true,
        },
        scrollbar: {
          el: component.querySelector('.testimonial-slider_draggable_wrap'),
          draggable: true,
          dragClass: 'testimonial-slider_draggable_handle',
          snapOnRelease: true,
        },
      });
    });
    initSliders();
    window.addEventListener('resize', initSliders);
  }
});
